// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme fallbacks */
/* Solid gold accents (no gradients) */
.rsvp {
  font-family: "Almendra", serif;
  padding-left: 1rem;
  padding-right: 1rem;
}

/* Shell */
.rsvp__shell {
  position: relative;
  border-radius: 999px;
  background: #ffffff;
  border: 2px solid #d4af37; /* solid gold edge */
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  height: 60px;
  display: grid;
  place-items: center;
  overflow: hidden;
  transition: box-shadow 0.25s ease, transform 0.2s ease;
}
.rsvp__shell.is-done {
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

/* Fill bar behind the slider, using CSS var --progress */
.rsvp__fill {
  position: absolute;
  inset: 0 auto 0 0;
  width: var(--progress);
  background: rgba(212, 175, 55, 0.16); /* faint gold tint */
  border-radius: inherit;
  pointer-events: none;
  transition: width 0.1s linear;
}

/* The label centered above the track */
.rsvp__label {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: #0b0b0c;
  font-size: 1.05rem;
  letter-spacing: 0.2px;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

/* Native range stripped + themed */
.rsvp__range {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  background: transparent;
  margin: 0;
  outline: none;
  cursor: pointer;
}

/* Track (invisible—fill bar shows progress) */
.rsvp__range::-webkit-slider-runnable-track {
  height: 100%;
  background: transparent;
}

.rsvp__range::-moz-range-track {
  height: 100%;
  background: transparent;
}

/* Thumb (gold disc with white center) */
.rsvp__range::-webkit-slider-thumb {
  appearance: none;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: radial-gradient(circle at 50% 50%, #fff 0 10px, transparent 10px), #d4af37;
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: relative;
}

.rsvp__range::-moz-range-thumb {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  background: #d4af37;
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Focus ring */
.rsvp__range:focus-visible::-webkit-slider-thumb {
  outline: 3px solid rgba(146, 111, 52, 0.35);
}

.rsvp__range:focus-visible::-moz-range-thumb {
  outline: 3px solid rgba(146, 111, 52, 0.35);
}

/* Hint text */
.rsvp__hint {
  margin: 0.5rem 0 0;
  text-align: center;
  color: #6b7280;
  font-size: 0.95rem;
}

/* Compact on small screens */
@media (max-width: 520px) {
  .rsvp__shell {
    height: 56px;
  }
  .rsvp__label {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/RsvpSlideComponent/RsvpSlideComponent.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,oBAAA;AAKA,sCAAA;AAKA;EACE,8BAAA;EACA,kBAAA;EACA,mBAAA;AARF;;AAWA,UAAA;AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA,EAAA,oBAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sDAAA;AARF;AAUE;EAAY,2CAAA;EAAyC,2BAAA;AANvD;;AASA,yDAAA;AACA;EACE,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA,EAAA,oBAAA;EACA,sBAAA;EACA,oBAAA;EACA,6BAAA;AANF;;AASA,uCAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,cA/CQ;EAgDR,kBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AANF;;AASA,mCAAA;AACA;EACE,gBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;AANF;;AASA,8CAAA;AACA;EACE,YAAA;EACA,uBAAA;AANF;;AAQA;EACE,YAAA;EACA,uBAAA;AALF;;AAQA,wCAAA;AAGA;EAEE,gBAAA;EACA,WALW;EAMX,YANW;EAOX,oBAAA;EACA,sFACE;EAEF,sBAAA;EACA,yCAAA;EACA,kBAAA;AATF;;AAWA;EACE,WAhBW;EAiBX,YAjBW;EAkBX,oBAAA;EACA,mBA5FO;EA6FP,sBAAA;EACA,yCAAA;AARF;;AAWA,eAAA;AACA;EAAmD,2CAAA;AAPnD;;AAQA;EAAmD,2CAAA;AAJnD;;AAMA,cAAA;AACA;EACE,kBAAA;EACA,kBAAA;EACA,cA5GQ;EA6GR,kBAAA;AAHF;;AAMA,6BAAA;AACA;EACE;IAAe,YAAA;EAFf;EAGA;IAAe,eAAA;EAAf;AACF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n/* Theme fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Solid gold accents (no gradients) */\r\n$gold-1: #d4af37;\r\n\r\n$radius: if(global-variable-exists(btn-radius), $btn-radius, 16px);\r\n\r\n.rsvp {\r\n  font-family: 'Almendra', serif;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n/* Shell */\r\n.rsvp__shell {\r\n  position: relative;\r\n  border-radius: 999px;\r\n  background: #ffffff;\r\n  border: 2px solid $gold-1;         /* solid gold edge */\r\n  box-shadow: 0 8px 24px rgba(0,0,0,.06);\r\n  height: 60px;\r\n  display: grid;\r\n  place-items: center;\r\n  overflow: hidden;\r\n  transition: box-shadow .25s ease, transform .2s ease;\r\n\r\n  &.is-done { box-shadow: 0 10px 28px rgba(0,0,0,.08); transform: translateY(-1px); }\r\n}\r\n\r\n/* Fill bar behind the slider, using CSS var --progress */\r\n.rsvp__fill {\r\n  position: absolute;\r\n  inset: 0 auto 0 0;\r\n  width: var(--progress);\r\n  background: rgba($gold-1, .16);     /* faint gold tint */\r\n  border-radius: inherit;\r\n  pointer-events: none;\r\n  transition: width .1s linear;\r\n}\r\n\r\n/* The label centered above the track */\r\n.rsvp__label {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: grid;\r\n  place-items: center;\r\n  color: $text;\r\n  font-size: 1.05rem;\r\n  letter-spacing: .2px;\r\n  user-select: none;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Native range stripped + themed */\r\n.rsvp__range {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: transparent;\r\n  margin: 0;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Track (invisible—fill bar shows progress) */\r\n.rsvp__range::-webkit-slider-runnable-track {\r\n  height: 100%;\r\n  background: transparent;\r\n}\r\n.rsvp__range::-moz-range-track {\r\n  height: 100%;\r\n  background: transparent;\r\n}\r\n\r\n/* Thumb (gold disc with white center) */\r\n$rsvp-thumb: 36px;\r\n\r\n.rsvp__range::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: $rsvp-thumb;\r\n  height: $rsvp-thumb;\r\n  border-radius: 999px;\r\n  background:\r\n    radial-gradient(circle at 50% 50%, #fff 0 10px, transparent 10px),\r\n    $gold-1;\r\n  border: 2px solid #fff;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,.2);\r\n  position: relative;\r\n}\r\n.rsvp__range::-moz-range-thumb {\r\n  width: $rsvp-thumb;\r\n  height: $rsvp-thumb;\r\n  border-radius: 999px;\r\n  background: $gold-1;\r\n  border: 2px solid #fff;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,.2);\r\n}\r\n\r\n/* Focus ring */\r\n.rsvp__range:focus-visible::-webkit-slider-thumb { outline: 3px solid rgba($primary, .35); }\r\n.rsvp__range:focus-visible::-moz-range-thumb     { outline: 3px solid rgba($primary, .35); }\r\n\r\n/* Hint text */\r\n.rsvp__hint {\r\n  margin: .5rem 0 0;\r\n  text-align: center;\r\n  color: $muted;\r\n  font-size: .95rem;\r\n}\r\n\r\n/* Compact on small screens */\r\n@media (max-width: 520px) {\r\n  .rsvp__shell { height: 56px; }\r\n  .rsvp__label { font-size: 1rem; }\r\n  $rsvp-thumb: 32px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
